<template>
  <main class="user-detail-popup">
    <div class="wrapper fx-col">
      <div class="user-wrapper-outer">
        <div class="wrapper-title">
          <span>회사정보</span>
          <button class="btn-save user-btn-bg" @click="userInfoUpdate">저장</button>
        </div>
        <div class="middle-wrap">
          <table>
            <tbody>
              <tr class="content">
                <td class="title">아이디</td>
                <td>
                  <span>{{ userData.memId }}</span>
                </td>
              </tr>
              <tr class="content">
                <td class="title">도메인</td>
                <td>
                  <input type="text" v-model="userData.domain" />
                </td>
              </tr>
              <tr class="content">
                <td class="title">크레딧</td>
                <td>
                  <span>{{ userData.creditAmt }}</span>
                </td>
              </tr>
              <tr class="content">
                <td class="title">보유포인트</td>
                <td>
                  <span>{{ userData.pointAmt }}</span>
                </td>
              </tr>
              <tr class="content">
                <td class="title">하위 컴퍼니 수</td>
                <td>
                  <span>{{ userData.subCompanyCnt }}</span>
                  <!-- <span>-</span> -->
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-div-line"></div>
          <table class="date-table">
            <tbody>
              <tr class="content">
                <td class="title">회사등급</td>
                <td>
                  <span>{{$t(userData.partnerType)}}</span>
                </td>
              </tr>
              <tr class="content">
                <td class="title">회사명</td>
                <td>
                  <input type="text" v-model="userData.memName" />
                </td>
              </tr>
              <tr class="content">
                <td class="title">보유머니</td>
                <td>
                  <span>{{ userData.cashAmt }}</span>
                </td>
              </tr>
              <tr class="content">
                <td class="title"></td>
                <td>
                  <!-- <span>{{ userData.cashAmt }}</span> -->
                </td>
              </tr>
              <tr class="content">
                <td class="title">총 회원 수</td>
                <td>
                  <!-- <span>-</span> -->
                  <span>{{ userData.subMemCount }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="middle-wrap">
          <table>
            <tbody>
              <tr class="content">
                <td class="title">비밀번호</td>
                <td>
                  <input type="password" v-model="userData.memPass" />
                </td>
              </tr>
              <tr class="content">
                <td class="title">컴퍼니 제한수</td>
                <td>
                  <input type="number" v-model="userData.recommendLimit" />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-div-line"></div>
          <table class="date-table">
            <tbody>
              <tr class="content">
                <td class="title">비밀번호 확인</td>
                <td>
                  <input type="password" v-model="userData.memPass" />
                </td>
              </tr>
              <tr class="content">
                <td class="title">회원 제한수</td>
                <td>
                  <input type="number" v-model="userData.recommendLimit" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="control-wrap" data-v-2e18a525="">
          <div class="button-wrap" data-v-2e18a525="">
            <button class="user-btn-bg" type="button">알 지급내역</button>
            <button class="user-btn-bg" type="button">알 환전내역</button>
            <button class="user-btn-bg" type="button" data-link="withdraw" @click="cashInModal.active = !cashInModal.active">알지급</button>
            <button class="user-btn-bg" type="button" data-link="point" @click="cashOutModal.active = !cashOutModal.active">알환전</button>
          </div>
        </div>
      </div>
      <div class="user-wrapper-outer">
        <div class="wrapper-title">
          <span>회사통계</span>
        </div>
        <div class="middle-wrap">
          <table>
            <tbody>
              <tr class="content">
                <td class="title">총 입금</td>
                <td>
                  <span>{{ userData.totalCashInAmt }}</span>
                </td>
              </tr>
              <tr class="content">
                <td class="title">총 보험포인트</td>
                <td>0</td>
              </tr>
              <tr class="content">
                <td class="title">총 베팅금</td>
                <td>
                  <span>{{ userData.totalWlAmt }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-div-line"></div>
          <table class="date-table">
            <tbody>
              <tr class="content">
                <td class="title">총 출금</td>
                <td>
                  <span>{{ userData.totalCashOutAmt }}</span>
                </td>
              </tr>
              <tr class="content">
                <td class="title"></td>
                <td></td>
              </tr>
              <tr class="content">
                <td class="title">총 윈루즈</td>
                <td>
                  <span>{{ userData.totalWlAmt }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="control-wrap">
          <div class="button-wrap">
            <!-- <button class="user-btn-bg" type="button" data-link="betList" @click="parentLinkMove('/reports/totalList', userData.siteId)">베팅내역</button> -->
            <!-- <button class="user-btn-bg" type="button" data-link="betList" @click="parentLinkMove('/reports/totalList', userData.siteId)">크레딧내역</button> -->
            <!-- <button class="user-btn-bg" type="button" data-link="deposit" @click="parentLinkMove('/cash/in/report', userData.siteId)">입금내역</button>
            <button class="user-btn-bg" type="button" data-link="withdraw" @click="parentLinkMove('/cash/out/report', userData.siteId)">출금내역</button>
            <button class="user-btn-bg" type="button" data-link="point" @click="parentLinkMove('/pointList', userData.siteId)">포인트내역</button> -->
          </div>
        </div>
      </div>
      <div class="user-wrapper-outer">
        <div class="wrapper-title">
          <span>상위컴퍼니 리스트</span>
        </div>
        <div class="middle-wrap">
          <div class="supComp-list-wrap">
            <span class="compColor1">mvptest</span>
            <span class="compColor-target">{{ userData.memName }}</span>
          </div>
        </div>
      </div>
      <div class="user-wrapper-outer">
        <div class="wrapper-title">
          <span>하위컴퍼니 리스트</span>
        </div>
        <div class="middle-wrap">
          <div class="table-wrap">
            <table class="mainTable">
              <thead>
                <tr>
                  <th>아이디</th>
                  <th>회원등급</th>
                  <th>보유머니</th>
                  <th>보유포인트</th>
                  <th>생성일</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{}}</td>
                  <td>마스터</td>
                  <td>625,834,952</td>
                  <td>6,258,349,520</td>
                  <td>2022-04-01 23:35:04</td>
                </tr>
                <tr>
                  <td>playDot</td>
                  <td>에이전시</td>
                  <td>625,834,952</td>
                  <td>6,258,349,520</td>
                  <td>2022-04-01 23:35:04</td>
                </tr>
                <tr>
                  <td>play4435</td>
                  <td>에이전시</td>
                  <td>625,834,952</td>
                  <td>6,258,349,520</td>
                  <td>2022-04-01 23:35:04</td>
                </tr>
                <tr>
                  <td>play216</td>
                  <td>마스터</td>
                  <td>625,834,952</td>
                  <td>6,258,349,520</td>
                  <td>2022-04-01 23:35:04</td>
                </tr>
                <tr>
                  <td>play221</td>
                  <td>마스터</td>
                  <td>625,834,952</td>
                  <td>6,258,349,520</td>
                  <td>2022-04-01 23:35:04</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper fx-col">
      <div class="user-wrapper-outer" style="flex: 0">
        <div class="wrapper-title">
          <span>기능 설정</span>
          <button class="btn-save user-btn-bg" @click="userSettingUpdate">저장</button>
        </div>
        <div class="middle-wrap">
          <table>
            <tbody>
              <tr class="content">
                <td class="title">입금 가능</td>
                <td class="td-toggle">
                  <div class="toggle-wrap">
                    <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.loginYn" />
                  </div>
                </td>
              </tr>
              <tr class="content">
                <td class="title">상위보험사용</td>
                <td class="td-toggle">
                  <div class="toggle-wrap">
                    <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.recommendYn" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-div-line"></div>
          <table class="date-table">
            <tbody>
              <tr class="content">
                <td class="title">출금 가능</td>
                <td class="td-toggle">
                  <div class="toggle-wrap">
                    <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.betYn" />
                  </div>
                </td>
              </tr>
              <tr class="content">
                <td class="title">하위보험사용</td>
                <td class="td-toggle">
                  <div class="toggle-wrap">
                    <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.recommendYn" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-div-line"></div>
          <table class="date-table">
            <tbody>
              <tr class="content">
                <td class="title">베팅 가능</td>
                <td class="td-toggle">
                  <div class="toggle-wrap">
                    <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.recommendYn" />
                  </div>
                </td>
              </tr>
              <tr class="content">
                <td class="title"></td>
                <td class="td-toggle"></td>
              </tr>
            </tbody>
          </table>
          <div class="table-div-line"></div>
          <table class="date-table">
            <tbody>
              <tr class="content">
                <td class="title">사이트 운전</td>
                <td class="td-toggle">
                  <div class="toggle-wrap">
                    <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.recommendYn" />
                  </div>
                </td>
              </tr>
              <tr class="content">
                <td class="title"></td>
                <td class="td-toggle"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="user-wrapper-outer">
        <div class="wrapper-title">
          <span>게임별 요율설정</span>
          <button class="btn-save user-btn-bg" @click="userRateUpdate">저장</button>
        </div>
        <div class="wrapper-contents s-content-wrap">
          <template v-for="item in gameList" :key="item.code">
            <div class="s-content">
              <div class="title">
                <span>{{ item.gameTxtKey }}</span>
              </div>
              <div class="content">
                <select v-model="item.rateList.pointRate">
                  <template v-for="(n, index) in item.rateLoop + 1" :key="index">
                    <option :value="(index * 0.05).toFixed(2)">
                      {{ (index * 0.05).toFixed(2) }}
                    </option>
                  </template>
                </select>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="user-wrapper-outer">
        <div class="wrapper-title">
          <span>게임별 베팅설정</span>
          <button class="btn-save user-btn-bg" @click="userRateUpdate">저장</button>
        </div>
        <div class="wrapper-contents s-content-wrap">
          <template v-for="item in gameList" :key="item.code">
            <div class="s-content">
              <div class="title">
                <span>{{ item.gameTxtKey }}</span>
              </div>
              <div class="content">
                <div class="toggle-wrap">
                  <span class="toggle_text" :class="item.rateList.betYn ? 'on' : 'off'"></span>
                  <input type="checkbox" class="set-switch" v-model="item.rateList.betYn" />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="user-wrapper-outer user-memo-wrap">
        <div class="wrapper-title">
          <span>메모</span>
          <button class="btn-save user-btn-bg" @click="userMemoUpdate">저장</button>
        </div>
        <div class="content">
          <textarea id="accessDesc" name="accessDesc" v-model="userData.memo"></textarea>
        </div>
      </div>
    </div>
    <div class="modalWrap" v-if="cashInModal.active">
      <div class="modal-item">
        <article class="modal-title">
          <sub-title :text="`알지급`" />
          <button class="btn-link modal-close" type="button" @click="inCashModalClose">
            <i class="fas fa-times-circle"></i>
          </button>
        </article>
        <article class="fx-item-auto">
          <input type="number" v-model="cashInModal.reqData.inAmt" />
        </article>
        <div class="fx-col-end btn-wrap">
          <button class="btn-layout btn-blue" type="button" @click="cashApply('in', userData.siteId)">지급</button>
        </div>
      </div>
    </div>
    <div class="modalWrap" v-if="cashOutModal.active">
      <div class="modal-item">
        <article class="modal-title">
          <sub-title :text="`알회수`" />
          <button class="btn-link modal-close" type="button" @click="outCashModalClose">
            <i class="fas fa-times-circle"></i>
          </button>
        </article>
        <article class="fx-item-auto">
          <!-- <div>금액</div> -->
          <input type="number" v-model="cashOutModal.reqData.outAmt" />
        </article>
        <div class="fx-col-end btn-wrap">
          <button class="btn-layout btn-blue" type="button" @click="cashApply('out', userData.siteId)">회수</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import {getCode} from '@/api/utils'
import { replceDateT, numberWithCommas } from "@/libs/utils.js";
import { GAME_INFO_LIST } from "@/libs/constants.js";
import subTitle from "@/components/main/PageSubTitle";

export default {
  name: "userDetail",
  components: {
    subTitle
  },
  data() {
    return {
      reqData: {
        memId: this.$route.query.id
      },
      cashInModal: {
        active: false,
        text: "입금",
        reqData: {
          siteId: "",
          inBonusYn: "N",
          inAmt: 0,
          memo: "",
          type: "N"
        }
      },
      cashOutModal: {
        active: false,
        text: "출금",
        reqData: {
          siteId: "",
          bonusRollingYn: "N",
          outAmt: 0,
          memo: "",
          type: "N"
        }
      },
      creditInModal: {
        active: false,
        text: "크레딧 지급",
        reqData: {
          siteId: "",
          bonusRollingYn: "N",
          outAmt: 0,
          memo: "",
          type: "N"
        }
      },
      creditOutModal: {
        active: false,
        text: "크레딧 회수",
        reqData: {
          siteId: "",
          bonusRollingYn: "N",
          outAmt: 0,
          memo: "",
          type: "N"
        }
      },
      userRate: [],
      gameList: [],
      rateUpdate: {
        siteId: "",
        rateList: []
      },
      modifyData: {
        siteId: "",
        memNick: "",
        memName: "",
        memStatus: "",
        recommenderId: "",
        loginYn: "",
        betYn: "",
        recommendYn: "",
        memBlackYn: "",
        memLockYn: "",
        accInfoRequestYn: "",
        memLevel: "",
        sportsLevel: "",
        casinoLevel: "",
        slotLevel: "",
        mgLevel: "",
        pointExchangeYn: "",
        memo: "",
        memberCommissionRate: [
          {
            gameType: "",
            pointRate: "",
            useYn: "",
            betYn: ""
          }
        ],
        memberGameBetYn: [
          {
            gameType: "",
            pointRate: "",
            useYn: "",
            betYn: ""
          }
        ]
      }
    };
  },
  methods: {
    async _memLogout(siteId) {
      const reqData = {
        siteId: siteId
      };
      const res = await memLogout(reqData);
      if (res.resultCode === "0") {
        alert("로그아웃 처리 완료");
      } else {
        alert("로그아웃 처리 실패");
      }
    },
    async cashApply(type, siteId) {
      let res = "";
      if (type === "in") {
        this.cashInModal.reqData.siteId = siteId;
        res = await cashIn(this.cashInModal.reqData);
        if (res.resultCode === "0") {
          alert("입금완료");
          this.getUserDetail();
          this.cashInModal.reqData.inAmt = 0;
        } else {
          alert("입금실패, 다시 시도해주세요.");
        }
      } else if (type === "out") {
        if (this.userData.cashAmt < this.cashOutModal.reqData.outAmt) {
          this.cashOutModal.reqData.outAmt = 0;
          alert("출금액은 보유금액보다 적어야 합니다.");
          return;
        }
        this.cashOutModal.reqData.siteId = siteId;
        res = await cashOut(this.cashOutModal.reqData);
        if (res.resultCode === "0") {
          alert("출금완료");
          this.getUserDetail();
          this.cashOutModal.reqData.outAmt = 0;
        } else {
          alert("출금실패, 다시 시도해주세요.");
        }
      }
    },
    async userInfoUpdate() {
      const reqData = {
        siteId: this.userData.siteId,
        memNick: this.userData.memNick,
        memName: this.userData.memName,
        memLevel: this.userData.memLevel
      };
      const res = await memberModify(reqData);
      if (res.resultCode === "0") {
        alert("회원정보수정 완료");
      } else {
        alert("회원정보 변경실패, 다시 시도해주세요.");
      }
    },
    async userMemoUpdate() {
      const reqData = {
        siteId: this.userData.siteId,
        memo: this.userData.memo
      };
      const res = await memberModify(reqData);
      if (res.resultCode === "0") {
        alert("상담메모수정 완료");
      } else {
        alert("상담메모수정실패, 다시 시도해주세요.");
      }
    },
    async userGLevelUpdate() {
      const reqData = {
        siteId: this.userData.siteId,
        sportsLevel: this.userData.sportsLevel,
        casinoLevel: this.userData.casinoLevel,
        slotLevel: this.userData.slotLevel,
        mgLevel: this.userData.mgLevel
      };
      const res = await memberModify(reqData);
      if (res.resultCode === "0") {
        alert("게임레벨 수정 완료");
      } else {
        alert("게임레벨 수정 실패, 다시 시도해주세요.");
      }
    },
    async userRateUpdate() {
      const reqData = {
        siteId: this.userData.siteId,
        memNick: this.userData.memNick,
        memName: this.userData.memName,
        rateList: []
      };
      console.log(this.gameList);
      for (const item of this.gameList) {
        const rateList = item.rateList;
        if (rateList.betYn) {
          rateList.betYn = "Y";
        } else {
          rateList.betYn = "N";
        }
        if (rateList.useYn) {
          rateList.useYn = "Y";
        } else {
          rateList.useYn = "Y";
        }
        reqData.rateList.push(rateList);
      }
      const res = await memberModify(reqData);
      // await this.getUserDetail();
      // await this.setRateList();
      if (res.resultCode === "0") {
        alert("베팅설정 완료");
      } else {
        alert("베팅설정 실패, 다시 시도해주세요.");
      }
      location.reload();
    },
    async userSettingUpdate() {
      const reqData = {
        siteId: this.userData.siteId,
        accInfoRequestYn: this.userData.accInfoRequestYn,
        betYn: this.userData.betYn,
        siteStatusYn: this.userData.betYn,
        insuredUpYn: this.userData.insuredUpYn,
        insuredDownYn: this.userData.insuredDownYn
      };
      for (const item in reqData) {
        if (item !== "siteId") {
          if (reqData[item]) {
            reqData[item] = "Y";
          } else {
            reqData[item] = "N";
          }
        }
      }
      const res = await memberModify(reqData);
      if (res.resultCode === "0") {
        alert("기능설정 완료");
      } else {
        alert("기능설정 실패, 다시 시도해주세요.");
      }
    },
    parentLinkMove(linkTarget, siteId) {
      console.log("move");
      if (linkTarget === "/reports/totalList") {
        window.opener.location.href = `${linkTarget}?id=${siteId}`;
      } else {
        window.opener.location.href = `/user${linkTarget}?id=${siteId}`;
      }
    },
    async getSubMemberInfo() {
      const reqData = {
        targetId: this.reqData.memId,
        searchType: "partner"
      };
      const res = await memberTreeList(reqData);
      const list = res.data.list;
      if (list) {
        this.userData.subMemCnt = list.length;
      } else {
        this.userData.subMemCnt = 0;
      }
    },
    switchToggle(event) {
      const toggle = event.target;
      const text = toggle.previousElementSibling;
      // console.log(toggle.checked)
      if (text) {
        if (toggle.checked) {
          text.classList.remove("off");
          text.classList.add("on");
        } else {
          text.classList.remove("on");
          text.classList.add("off");
        }
      }
    },
    inCashModalClose() {
      this.cashInModal.active = !this.cashInModal.active;
    },
    outCashModalClose() {
      this.cashOutModal.active = !this.cashOutModal.active;
    },
    modalControl(siteId) {
      this.getUserDetail(siteId);
      this.modal.target = siteId;
      this.modal.active = !this.modal.active;
    },
    writeOpen() {
      // window.open("/cms/message/write", "msgWirte", "top=100,left=150,scrollbars=no,resizable=no,width=480,height=605,status=no");
    },
    historyOpen() {
      // window.open("/cms/cash/history", "cashHistory", "top=100,left=150,scrollbars=no,resizable=no,width=565,height=701,status=no");
    },
    async getUserDetail() {
      const res = await userDetail(this.reqData);
      if(res.data.member){
        Object.assign(this.userData,res.data.member);
      }

      if (this.userData.lastLoginDt) {
        this.userData.lastLoginDt = replceDateT(this.userData.lastLoginDt);
      }
      this.userData.totalWlAmt = numberWithCommas(this.userData.totalWlAmt);
      this.userData.totalLoginCount = numberWithCommas(this.userData.totalLoginCount);
      this.userData.totalCashOutAmt = numberWithCommas(this.userData.totalCashOutAmt);
      this.userData.totalCashInAmt = numberWithCommas(this.userData.totalCashInAmt);
      this.userData.totalBonusAmt = numberWithCommas(this.userData.totalBonusAmt);
      for (const item in this.userData) {
        if (item.indexOf("Yn") !== -1 && item !== "memberCommissionRate") {
          if (this.userData[item] === "Y") {
            this.userData[item] = true;
          } else {
            this.userData[item] = false;
          }
        }
      }
      this.rateUpdate.siteId = res.data.member.siteId;
      this.rateUpdate.siteId = res.data.member.siteId;
    },
    getUserRate() {
      return memberRate(this.reqData);
    },
    getGameCode() {
      return getGameCodes("kplay");
    },
    setRateLoop(maxRate) {
      return maxRate / 0.05;
    },
    getMemLevel() {
      this.userData;
    },
    async setMemStatus() {
      const reqData = {
        siteId: this.userData.siteId,
        memStatus: this.userData.memStatus
      };
      try {
        const res = await memStatusChange(reqData);
        if (res.resultCode !== "0") {
          alert("회원상태 변경에 실패했습니다. 다시 시도해주세요.");
        } else {
          alert("회원상태 변경완료");
        }
      } catch (e) {
        console.log(e);
        alert("회원상태 변경에 실패했습니다. 다시 시도해주세요.");
      }
    },
    setRateList() {
      for (const loop of this.userData.memberCommissionRate) {
        const groupCode = loop.groupCode;
        console.log(loop);
        const gameCode = loop.gameType;
        if (loop.useYn === "Y") {
          loop.useYn = true;
        } else {
          loop.useYn = false;
        }
        if (loop.betYn === "Y") {
          loop.betYn = true;
        } else {
          loop.betYn = false;
        }
        const gTxtCode = GAME_INFO_LIST[groupCode][gameCode.toString()];
        if (gTxtCode) {
          const gameTextKey = this.$t(`gameList.${gTxtCode}`);
          const rateObj = {
            gameTxtKey: gameTextKey,
            rateLoop: this.setRateLoop(Number(loop.maxPointRate)),
            rateList: {
              gameType: gameCode,
              pointRate: loop.pointRate,
              useYn: loop.useYn,
              betYn: loop.betYn
            }
          };
          this.gameList.push(rateObj);
        }
      }
      console.log(this.gameList);
    }
  },
  async created() {
    await this.getUserDetail();
    this.setRateList();
    await this.getSubMemberInfo();
  }
};
</script>

<style scoped>
.active .btn-t-inner {
  display: none;
}
.fstColumn.userList .levelColor {
  display: block;
}

.box-hideOpen .levelColor {
  background: rgb(255, 218, 38);
  width: 8px;
}
.seletAndDelete {
  display: flex;
  align-items: center;
}
.msg-all-sel {
  margin-right: 4px !important;
  height: 30px;
  box-sizing: border-box;
}
#siteId {
  margin-right: 4px;
}
.btn-state-change.cancle {
  margin-right: 4px;
}
.user-detail-popup {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  width: 1435px;
  margin: 0;
  box-sizing: border-box;
}
.user-detail-popup select {
  font-size: 1em;
}
.wrapper-title .btn-save {
  padding: 0 12px;
}
.button-wrap {
  display: flex;
}
.button-wrap > button {
  flex: 1;
  margin-right: 4px;
}
.button-wrap > button:last-child {
  margin-right: 0;
}
input[type="text"],
input[type="number"],
input[type="password"] {
  font-weight: 500;
  border: 1px solid #c5c5c5;
  height: 21px;
  padding: 0 6px;
  box-sizing: border-box;
  border-radius: 3px;
}
select {
  border: 1px solid #c5c5c5;
}
.userInfo-select {
  font-weight: 500;
  padding: 2px 5px;
  height: 21px;
  width: 100%;
}
.s-content > .content {
  display: flex;
  height: calc(56px - 26px);
}
.modal-item {
  width: 38%;
  margin: 0 auto;
  position: relative;
  top: 20%;
  background: #fff;
  padding: 10px;
}
.sub-title > h3 {
  width: fit-content;
}
.table-wrap {
  width: 100%;
  overflow-y: scroll;
  max-height: 120px;
}
.mainTable {
  font-size: 12px !important;
}
.mainTable th {
  height: 35px;
  /* background: var(--main); */
  background: #18698b;
  color: #fff;
  font-weight: 700;
  vertical-align: middle;
}

.supComp-list-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
span[class^="compColor"] {
  font-weight: bold;
}
span[class^="compColor"]:after {
  content: "▶";
  display: inline;
  margin-left: 5px;
}
span[class^="compColor"]:last-child:after {
  content: "";
}
.compColor-target {
  color: red;
}
</style>
